module.exports = __webpack_public_path__ + "img/case-bank.f0176ae3.png";